import Api from 'src/api/Base'

class GetCycles extends Api {
  requestUrl = `/api/Cycle`
}
export default GetCycles
